import React, { useState, useEffect, useContext, useRef } from "react";
import { API_URL } from "../components/api";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
} from "@mui/x-data-grid";
import Checkbox from "@mui/material/Checkbox";
import CustomizedActions from "./BulkActions";
import AuthContext from "../context/AuthContext";
import Formsa from "./editsub";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import ProgressBar from "./progress.js";
import "./Internet.css";
import Ping from "../components/SubscriptionPing";
import ConsumptionHistory from "./consumptionHistory";
import TransferDays from "./TransferDays";
import ExcelSVG from "../../ExcelSVG.svg";
import FilterSVG from "../../FilterSVG.svg";
import * as XLSX from "xlsx";
import Button from "react-bootstrap/Button";

function SubInternet() {
  const { user } = useContext(AuthContext);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [checkedRows, setCheckedRows] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const [showo, setShowo] = useState(false);
  const [password, setpassword] = useState(0);
  const handleshowo = () => setShowo(true);
  const handleedit = () => setShowo(false);

  const [showPing, setShowPing] = useState(false);
  const handleshowPing = () => setShowPing(true);
  const handleClosePing = () => setShowPing(false);

  const [showHistory, setShowHistory] = useState(false);
  const handleshowHistory = () => setShowHistory(true);
  const handleCloseHistory = () => setShowHistory(false);

  const [selectedSubscriptionId, setSelectedSubscriptionId] = useState(0);
  const handleUpdateAct = (id) => setSelectedSubscriptionId(id);

  const [showTransfer, setShowTransfer] = useState(false);
  const handleshowTransfer = () => setShowTransfer(true);
  const handleCloseTransfer = () => setShowTransfer(false);

  const [subscriptionDetails, setSubscriptionDetails] = useState({
    username: "",
    password: 0,
    subId: 0,
    intSubId: 0,
    intPlanId: 0,
    site: "",
    planName: "",
    fullName: "",
    expDate: "",
    consumption: "",
    quotaOption: "",
    fullQuota: 0,
    connectivity: "",
    due: "",
    notes: "",
    site_name: "",
    WAP: "",
    core: "",
    cpe_mac_address: "",
  });

  const [filters, setFilters] = useState({
    status: "",
    username: "",
    planName: "",
    fullName: "",
    ip_address: "",
    expiration_date: "",
    consumption: "",
    connectivity: "",
    connectivity_dependent: "",
    due: "",
    mac_address: "",
  });
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [gridFilterModel, setGridFilterModel] = useState({
    items: [],
  });

  const [searchInput, setSearchInput] = useState("");

  // NEW: State to track column visibility
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({});
  const [searchFilterTimeout, setSearchFilterTimeout] = useState(null);

  const updateSubscriptionDetails = (details) => {
    setSubscriptionDetails(details);
  };

  const [currentPage, setCurrentPage] = useState(0);

  const fetchData = async () => {
    try {
      const authTokens = JSON.parse(localStorage.getItem("authTokens"));
      const response = await axios.get(`${API_URL}/radius/subscriptions/`, {
        headers: {
          Authorization: `Bearer ${authTokens.access}`,
        },
        params: {
          username: user.username,
        },
      });

      if (response.status === 200) {
        setData(response.data);
        console.log(response.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Fetch data when the component mounts
    fetchData();

    // Set up a timer to fetch data every 5 seconds
    const intervalId = setInterval(fetchData, 5000);

    // Clean up the timer when the component unmounts
    return () => clearInterval(intervalId);
  }, [user.username]);

  const getStatusCellStyle = (params) => {
    let statusColor = "";
    switch (params.value) {
      case "offline":
        statusColor = "status-offline";
        break;
      case "online":
        statusColor = "status-online";
        break;
      case "inactive":
        statusColor = "status-inactive";
        break;
      case "expired":
        statusColor = "status-expired";
        break;
      case "hold":
        statusColor = "status-hold";
        break;
      case "HSI":
        statusColor = "status-hsi";
        break;
      default:
        break;
    }
    return statusColor;
  };

  const getPercentageCellValue = (params) => {
    if (params.row.plan_name.includes("STARTER")) {
      return params.row.monthly_percentage + "%";
    }
    return params.row.percentage + "%";
  };

  const columns = [
    {
      field: "checkbox",
      headerName: "",
      width: 30,
      renderCell: (params) => (
        <Checkbox
          className="subcheck"
          checked={checkedRows.includes(params.row.subscription_id)}
          onChange={(event) =>
            handleCheckboxChange(event, params.row.subscription_id)
          }
        />
      ),
    },
    {
      field: "status",
      headerName: "Status",
      width: 70,
      cellClassName: (params) => getStatusCellStyle(params), // Apply cell style based on status
    },
    { field: "username", headerName: "Username", width: 85 },
    {
      field: "fullname_en",
      headerName: "Full Name",
      flex: 2,
      minWidth: 250,
    },
    {
      field: "plan_name",
      headerName: "Plan Name",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
        // Check if the plan_name includes "BASIC" to determine which percentage to use
        const percentage = params.row.plan_name.includes("STARTER")
          ? params.row.monthly_percentage
          : params.row.percentage;

        return (
          <ProgressBar
            percentage={percentage}
            planName={params.row.plan_name}
            max={params.row.daily_limit}
            download={params.row.pppoe_download}
            upload={params.row.pppoe_upload}
          />
        );
      },
    },
    { field: "ip_address", headerName: "IP Address", flex: 1, minWidth: 120 },
    {
      field: "subscription_secret",
      headerName: "Token",
      flex: 1,
      minWidth: 85,
    },

    {
      field: "site",
      headerName: "Site/Core",
      flex: 1,
      minWidth: 110,
    },
    {
      field: "quota_option",
      headerName: "Quota Option",
      flex: 1,
      minWidth: 110,
    },
    {
      field: "is_full",
      headerName: "Full",
      flex: 1,
      minWidth: 85,
      type: "boolean",
      valueGetter: (params) => Boolean(Number(params.row.is_full)),
      valueFormatter: (params) => (params.value ? "true" : "false"),
    },
    {
      field: "code",
      headerName: "Core",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "connectivity_dependent",
      headerName: "Connectivity Info",
      flex: 1,
      minWidth: 110,
      valueGetter: (params) => {
        if (params.row.connectivity === "Fiber") {
          return params.row.code || ""; // Use "code" for Fiber connectivity
        } else if (params.row.connectivity === "Wireless") {
          return params.row.wireless_access_point_name || ""; // Use WAP for Wireless connectivity
        }
        return ""; // Default to an empty string
      },
      renderCell: (params) => {
        if (params.row.connectivity === "Fiber") {
          return params.row.code; // Display "code" for Fiber connectivity
        } else if (params.row.connectivity === "Wireless") {
          return params.row.wireless_access_point_name; // Display WAP for Wireless connectivity
        }
        return ""; // Default display
      },
    },
    {
      field: "cpe_mac_address",
      headerName: "CPE Mac Address",
      flex: 1,
      minWidth: 170,
    },
    {
      field: "percentage",
      headerName: "Usage",
      flex: 1,
      minWidth: 70,
      valueGetter: (params) => getPercentageCellValue(params), // Get the appropriate value for percentage field
    },

    {
      field: "notes",
      headerName: "Notes",
      flex: 2,
      minWidth: 280,
    },

    {
      field: "expiration_date",
      headerName: "Expiry",
      flex: 1,
      minWidth: 120,
      valueFormatter: (params) => params.value.substring(0, 10),
    },
    {
      field: "actions",
      headerName: "Actions",
      minWidth: 220,
      flex: 1,
      renderCell: (params) => (
        <div className="subscription-row-actions">
          <div
            onClick={() => handleUpdateAct(params.row.subscription_id)}
          ></div>
          <button
            onClick={() => {
              const details = {
                username: params.row.username,
                password: params.row.password,
                subId: params.row.subscription_id,
                intSubId: params.row.internet_subscription_id,
                intPlanId: params.row.internet_plan_id,
                site: params.row.site,
                site_name: params.row.site_name,
                WAP: params.row.wireless_access_point_name,
                planName: params.row.plan_name,
                fullName: params.row.fullname_en,
                expDate: params.row.expiration_date,
                consumption: params.row.consumption_option,
                quotaOption: params.row.quota_option,
                fullQuota: Number(params.row.is_full) === 1 ? 1 : 0,
                connectivity: params.row.connectivity,
                due: params.row.due,
                ip: params.row.ip_address,
                notes: params.row.notes,
                core: params.row.code,
                cpe_mac_address: params.row.cpe_mac_address, // Param Added
              };
              updateSubscriptionDetails(details);
              handleshowo();
            }}
            className="edit-client"
          >
            Edit
          </button>
          <button
            onClick={() => {
              const details = {
                username: params.row.username,
                password: params.row.password,
                subId: params.row.subscription_id,
                intSubId: params.row.internet_subscription_id,
                intPlanId: params.row.internet_plan_id,
                site: params.row.site,
                planName: params.row.plan_name,
                fullName: params.row.fullname_en,
                expDate: params.row.expiration_date,
                consumption: params.row.consumption_option,
                connectivity: params.row.connectivity,
                due: params.row.due,
                ip: params.row.ip_address,
                notes: params.row.notes,
                nas: params.row.nas_ip_address,
              };
              updateSubscriptionDetails(details);
              handleshowPing();
            }}
            className="edit-client"
          >
            Ping
          </button>
          <button
            onClick={() => {
              const details = {
                subId: params.row.subscription_id,
                intSubId: params.row.internet_subscription_id,
              };
              updateSubscriptionDetails(details);
              handleshowHistory();
            }}
            className="edit-client"
          >
            History
          </button>
        </div>
      ),
    },
  ];

  const getRowId = (row) => row.subscription_id;

  const handleCheckboxChange = (event, subscriptionId) => {
    const checked = event.target.checked;
    setCheckedRows((prevCheckedRows) => {
      if (checked) {
        return [...prevCheckedRows, subscriptionId];
      } else {
        return prevCheckedRows.filter((id) => id !== subscriptionId);
      }
    });
  };

  // Create a delayed search filter function
  const delaySearchFilter = (input) => {
    setSearchQuery(input);
  };

  // Handle search input change
  useEffect(() => {
    // Save "searchValue" value before clearing other session storage items
    const searchValue = sessionStorage.getItem("searchDealerSubscription");

    // Clear all session storage items except "searchValue"
    Object.keys(sessionStorage).forEach((key) => {
      if (key !== "searchDealerSubscription") {
        sessionStorage.removeItem(key);
      }
    });

    // Restore "searchValue" value if needed
    if (searchValue) {
      sessionStorage.setItem("searchDealerSubscription", searchValue);
      setSearchQuery(searchValue);
      setSearchInput(searchValue); // Sync the searchInput with the restored value
    }
  }, []);

  // Handle search input change
  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchInput(query);
    sessionStorage.setItem("searchDealerSubscription", query);
    setCurrentPage(0);

    // Clear the previous timeout if it exists
    if (searchFilterTimeout) {
      clearTimeout(searchFilterTimeout);
    }

    // Set a new timeout to trigger filtering after a delay
    const newTimeout = setTimeout(() => {
      delaySearchFilter(query);
    }, 100); // Adjust the delay as needed
    setSearchFilterTimeout(newTimeout);
  };

  // IMPROVED: Combined filtering logic that works for both display AND export
  const filteredRows = data.filter((row) => {
    // Apply search query filter
    const searchMatch = searchQuery
      .split(" ")
      .every((word) =>
        Object.values(row).some((value) =>
          String(value).toLowerCase().includes(word.toLowerCase().trim())
        )
      );

    // Apply modal filters
    const modalFilterMatch = Object.keys(filters).every((key) => {
      if (!filters[key]) return true;

      if (key === "connectivity_dependent") {
        const filterValue = filters[key].toLowerCase();
        if (row.connectivity === "Fiber") {
          return (row.code || "").toLowerCase().includes(filterValue);
        } else if (row.connectivity === "Wireless") {
          return (row.name || "").toLowerCase().includes(filterValue);
        }
        return false;
      }

      const rowValue = String(row[key] || "").toLowerCase();
      const filterValue = String(filters[key]).toLowerCase();
      return rowValue.includes(filterValue);
    });

    // Apply DataGrid filters
    const gridFilterMatch = gridFilterModel.items.every((filterItem) => {
      if (!filterItem.value) return true;

      const cellValue = row[filterItem.field];
      const filterValue = filterItem.value;

      switch (filterItem.operator) {
        case "contains":
          return String(cellValue || "")
            .toLowerCase()
            .includes(String(filterValue).toLowerCase());
        case "equals":
          return String(cellValue || "") === String(filterValue);
        case "startsWith":
          return String(cellValue || "")
            .toLowerCase()
            .startsWith(String(filterValue).toLowerCase());
        case "endsWith":
          return String(cellValue || "")
            .toLowerCase()
            .endsWith(String(filterValue).toLowerCase());
        default:
          return true;
      }
    });

    return searchMatch && modalFilterMatch && gridFilterMatch;
  });

  const handleFilterChange = (field, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [field]: value,
    }));
  };

  const columnHeaders = {
    status: "Status",
    username: "Username",
    fullname_en: "Full Name",
    suffix: "Suffix",
    plan_name: "Plan Name",
    ip_address: "IP Address",
    site: "Site/Core",
    site_name: "Site Name",
    name: "Access Point",
    code: "Core",
    subscription_secret: "Token",
    connectivity: "Connectivity",
    consumption_option: "Option",
    due: "Due",
    mac_address: "Mac Address",
    expiration_date: "Expiry",
  };

  // NEW: Get the value for connectivity_dependent field properly
  const getConnectivityDependentValue = (row) => {
    if (row.connectivity === "Fiber") {
      return row.code || "";
    } else if (row.connectivity === "Wireless") {
      return row.name || "";
    }
    return "";
  };

  // Format date fields properly for export — e.g. "21/02/2025 10:25:52 AM"
  const formatDateForExport = (dateValue) => {
    if (!dateValue) return "";
    const date = new Date(dateValue);

    // Format as DD/MM/YYYY HH:MM:SS AM/PM
    const formattedDate = date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });

    // Ensure consistent spacing before AM/PM
    return formattedDate.replace(" am", " AM").replace(" pm", " PM");
  };

  // IMPROVED: Transform rows respecting column visibility
  const transformRowsForExport = (rows) => {
    return rows.map((row) => {
      const transformedRow = {};

      Object.keys(columnHeaders).forEach((field) => {
        // Check if column is visible (if not in columnVisibilityModel or explicitly true)
        const isVisible = columnVisibilityModel[field] !== false;

        if (isVisible) {
          const headerName = columnHeaders[field];

          // Handle special fields with computed values
          if (field === "connectivity_dependent") {
            transformedRow[headerName] = getConnectivityDependentValue(row);
          } else if (
            field === "payment_date" ||
            field === "expiration_date" ||
            field === "creation_date"
          ) {
            transformedRow[headerName] = formatDateForExport(row[field]);
          } else {
            transformedRow[headerName] = row[field] || "";
          }
        }
      });

      return transformedRow;
    });
  };

  // IMPROVED: Export function that uses the already-filtered rows
  const handleExportToExcel = () => {
    console.log("Exporting data...");
    console.log("Total data rows:", data.length);
    console.log("Filtered rows:", filteredRows.length);
    console.log("Active filters:", {
      search: searchQuery,
      modalFilters: filters,
      gridFilters: gridFilterModel.items,
    });
    console.log("Column visibility:", columnVisibilityModel);

    // Always use filteredRows which has ALL filters applied
    const transformedRows = transformRowsForExport(filteredRows);

    console.log("Rows to export:", transformedRows.length);

    const worksheet = XLSX.utils.json_to_sheet(transformedRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Subscription");
    XLSX.writeFile(workbook, "Subscription.xlsx");
  };

  const [isPressed, setIsPressed] = useState(false);

  const handleExportClick = () => {
    setIsPressed(true);
    handleExportToExcel();
    setTimeout(() => {
      setIsPressed(false);
    }, 200);
  };

  const handleDeselectCheckboxes = () => {
    setCheckedRows([]);
  };

  const CustomToolbar = () => (
    <GridToolbarContainer className="subscription-toolbar">
      <GridToolbarColumnsButton
        className="subscription-toolbar-action"
      />
      <Button
        className="subscription-toolbar-action"
        onClick={() => setShowFilterModal(true)}
        variant="outline-primary"
        style={{
          border: "none",
        }}
      >
        <img
          className="subscription-toolbar-icon"
          src={FilterSVG}
          alt="Filter Icon"
          style={{
            color: "white",
            width: "18px",
            marginRight: "8px",
            filter: "invert(0)", // keep black icon
          }}
        />
        Filter
      </Button>
      {/*<GridToolbarFilterButton />*/}
      <GridToolbarExport
        className="subscription-toolbar-action"
      />
      <Button
        className="subscription-toolbar-action"
        onClick={handleExportClick}
        variant="outline-success"
        style={{
          display: "flex",
          alignItems: "center",
          padding: "5px 10px",
          fontSize: "14px",
          border: "none",
          backgroundColor: isPressed ? "white" : "transparent",
          color: isPressed ? "black" : "#007bff",
          cursor: "pointer",
        }}
      >
        <img
          className="subscription-toolbar-icon"
          src={ExcelSVG}
          alt="Excel Icon"
          style={{
            width: "20px",
            marginRight: "8px",
            filter: isPressed ? "invert(0)" : "invert(1)",
          }}
        />
        Excel
      </Button>
    </GridToolbarContainer>
  );

  return (
    <div className="InternetTable reseller-subscription-table">
      <div className="actions reseller-subscription-actions">
        <CustomizedActions
          subscriptions={checkedRows}
          deselect={handleDeselectCheckboxes}
        />
        <button
          type="button"
          className="reseller-subscription-action-btn reseller-transfer-days-btn"
          aria-label="Open Transfer Days"
          onClick={handleshowTransfer}
        >
          Transfer Days
        </button>
        <style>{`
        .MuiDataGrid-panelWrapper {
          background: #122632 !important;
        }
      `}</style>
        <input
          type="text"
          placeholder="Search..."
          value={searchInput}
          onChange={handleSearchChange}
          className="search-client reseller-subscription-search"
        />
      </div>
      {!loading && data.length > 0 && (
        <div style={{ height: 520, width: "100%" }}>
          <DataGrid
            rows={filteredRows}
            columns={columns}
            getRowId={getRowId}
            filterModel={gridFilterModel}
            onFilterModelChange={(newModel) => setGridFilterModel(newModel)}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={(newModel) =>
              setColumnVisibilityModel(newModel)
            }
            components={{
              Toolbar: CustomToolbar,
            }}
            rowsPerPageOptions={[10, 100, 1000]}
            // Set the default page size to 10
            rowsPerPage={10} // Set the default number of rows per page to 10
            pagination
            disableSelectionOnClick
          />
        </div>
      )}
      <Modal
        show={showo}
        onHide={handleedit}
        className="modal-lg subscription-edit-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Subscription</Modal.Title>
        </Modal.Header>
        <div className="Subform">
          <Formsa
            key={subscriptionDetails.intSubId}
            su={subscriptionDetails.subId}
            intsu={subscriptionDetails.intSubId}
            intpa={subscriptionDetails.intPlanId}
            usr={subscriptionDetails.username}
            full={subscriptionDetails.fullName}
            sit={subscriptionDetails.site}
            con={subscriptionDetails.connectivity}
            opti={subscriptionDetails.consumption}
            plana={subscriptionDetails.planName}
            exp={subscriptionDetails.expDate}
            pass={subscriptionDetails.password}
            due={subscriptionDetails.due}
            quota={subscriptionDetails.quotaOption}
            isFull={subscriptionDetails.fullQuota}
            notes={subscriptionDetails.notes}
            site={subscriptionDetails.site_name}
            WAP={subscriptionDetails.WAP}
            core={subscriptionDetails.core}
            cpe_mac={subscriptionDetails.cpe_mac_address}
            closeModal={handleedit}
            fetch={fetchData}
            />
        </div>
      </Modal>
      <Modal show={showFilterModal} onHide={() => setShowFilterModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Filters</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {Object.keys(columnHeaders).map((field) => (
            <div key={field} className="filter">
              <label>{columnHeaders[field]}</label>
              <input
                type="text"
                placeholder={`Filter by ${columnHeaders[field]}`}
                value={filters[field] || ""}
                onChange={(e) => handleFilterChange(field, e.target.value)}
                className="filter-input"
              />
            </div>
          ))}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowFilterModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showTransfer}
        onHide={handleCloseTransfer}
        className="modal-xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Transfer Days</Modal.Title>
        </Modal.Header>
        <div className="Subform">
          <TransferDays />
        </div>
      </Modal>
      <Modal show={showPing} onHide={handleClosePing}>
        <Modal.Header closeButton>
          <Modal.Title>Ping</Modal.Title>
        </Modal.Header>
        <div className="Subform">
          {showPing && <Ping subscriptionId={subscriptionDetails.subId} />}
        </div>
      </Modal>
      <Modal show={showHistory} onHide={handleCloseHistory}>
        <Modal.Header closeButton>
          <Modal.Title>Consumpion</Modal.Title>
        </Modal.Header>
        <div className="Subform">
          <ConsumptionHistory sub={subscriptionDetails.subId} />
        </div>
      </Modal>
    </div>
  );
}

export default SubInternet;
